export const ACTIVITY_STATUS = {
  ativa: 'Ativa',
  pausada: 'Pausada',
  encerrada: 'Encerrada'
}

export const GOAL_HORIZON = {
  curto: 'Curto prazo',
  longo: 'Longo prazo'
}

export const GOAL_STATUS = {
  em_andamento: 'Em andamento',
  concluida: 'Concluída'
}

export const TOLERANCE_OPTIONS = [
  { value: 'boa', label: 'Boa' },
  { value: 'regular', label: 'Regular' },
  { value: 'baixa', label: 'Baixa' },
  { value: 'nao_tolerou', label: 'Não tolerou' }
]

export function toleranceLabel(value) {
  return TOLERANCE_OPTIONS.find((item) => item.value === value)?.label || value || '—'
}

export function painClass(score) {
  const value = Number(score)
  if (value <= 3) return 'is-low'
  if (value <= 6) return 'is-mid'
  return 'is-high'
}

export function doseLabel(activity) {
  const parts = []
  if (activity.frequency) parts.push(activity.frequency)
  const dose = [
    activity.sets != null && activity.sets !== '' ? `${activity.sets} séries` : null,
    activity.repetitions != null && activity.repetitions !== '' ? `${activity.repetitions} repetições` : null
  ].filter(Boolean)
  if (dose.length) parts.push(dose.join(' · '))
  return parts.join(' · ') || 'Sem frequência definida'
}

export function formatClock(value) {
  if (!value) return ''
  const text = String(value)
  const match = text.match(/(\d{2}:\d{2})/)
  return match ? match[1] : text.slice(0, 5)
}

export function blankCheck(activityId) {
  return {
    activityId,
    completed: false,
    setsDone: '',
    repetitionsDone: '',
    notes: ''
  }
}
